export const CONFIG = {
    APPNAME :{
      BEAGLEGPT: "BeagleGPT"
    },
    API: {
        // In case of SAAS Edition : it is  proxy's host address and in Enterprise Edition: backend server address
        BASEURL: "https://" + `${window.location.hostname}`,

        REQUESTMETHOD: {
            GET: 'GET',
            POST: 'POST',
            PUT: 'PUT',
            DELETE: 'DELETE',
        },
        BACKEND: '/backend/',
        URLQUERYPARAMS: {
            PAGE: '?page=',
            QUERY: '&query=',
            Id: '&id=',
        },
        REQUESTURL: {
            CREATENOTIFICATION: 'va_router/create-notification',
            GETNOTIFICATIONS: 'va_router/virtual-analyst/notification/get',
            UPDATENOTIFICATIONS: 'va_router/virtual-analyst/notification/',
            GETCARD: 'va_router/virtual-analyst/view/notification/card/',
            GETCARDHTML: '/virtual-analyst/media',
            GETTEAMS: 'va_router/virtual-analyst/teams/get',
            ADDCARDTONARRATIVEBOARD: 'va_router/virtual-analyst/insight/create',
            GETNARRATIVEBOARDCARDS: 'va_router/virtual-analyst/insight/get',
            GETFILTEREDNARRATIVEBOARDCARDS: '/virtual-analyst/search/insight',
            DELETENARRATIVEBOARDCARD: 'va_router/virtual-analyst/insight/delete/',
            GETNARRATIVEBOARDCARDHISTORY: 'va_router/virtual-analyst/insight/history/get/',
            GETCOMMENTS: 'va_router/virtual-analyst/comment/get',
            ADDCOMMENT: 'va_router/virtual-analyst/comment/create',
            EDITCOMMENT: 'va_router/virtual-analyst/comment/edit',
            DELETECOMMENT: 'va_router/virtual-analyst/comment/delete/',
            GETTEAMCARD: 'va_router/virtual-analyst/data/json',
            DEPENDENDFILTER: 'va_router/virtual-analyst/dependent-filters',
            PROCESSDEPENDENDFILTER: 'va_router/virtual-analyst/process-dependent-filters',
            GETTEAMMEMBERS: 'va_router/virtual-analyst/team/members/',
            SORTEDFILTERS: '/virtual-analyst/fetch_stored_filters',
            COLUMNFILTERDATA:'va_router/virtual-analyst/dynamic/filter-values',
            GETPVPCARD:'va_router/pvp/',
            DYNAMICFILTERS:'/dynamic-filter',
            REQUEST:'request/',
            DOWNLOADCSV: "va_router/virtual-analyst/data/csv",
            RUNSIMULATION:'va_router/pvp/run-simulation',
            UPDATEQUERY:'/update-query',
            LOGERROR: 'va_router/log/frontend-error',
            GETHOMEVAS:'va_router/virtual-analyst/details/vas',
            GETVADETAILS:'va_router/virtual-analyst/va/dataset-details',
            GETLOCATION:'va_router/virtual-analyst/send-location-data',
            VIRTUALANALYSTBOTS:'va_router/virtual-analyst/bots/',
            UPDATEAGENTSTATUS:'/users/update-access',
        },
        SUCCESSMESSAGE: 'Success',
        ERRORMESSAGE: {
            FAILEDTOFATCH: 'Failed to fetch',
            SERVERANAVAILABLE: 'Server is anavailable.',
            FORBIDDEN: 'Forbidden',
        },
    },
    // URLQUERYPARAMSEPERATOR:'-',
    URLQUERYPARAMSEPERATOR: '::dp::',
    PATH: {
        CREATENOTIFICATION: '/create-notification',
        EDITNOTIFICATION:'/edit-notification',
        NOTIFICATIONS: '/notifications',
        TABCONFIG: '/tab-config',
        NARRATIVEBOARD: '/narrative-board',
        ADDCARDTONARRATIVEBOARD: '/add-card-narrative-board',
        EMPTY: '/',
        CARDLIBRARY: '/card-library',
        PVPCARD:'/pvp-library',
        HOME:'/getting-started',
        DOWNLOADCSVROUTE: "/download-csv",
        GETLOCATION:"/get-current-location"
    },
    LOADER_TEXT: 'Loading...',
    LOADING_TIME: 500,
    TAB_CONFIG: {
        TAB_CONFIG_MSG: 'Please accept the following terms for MS Team tab configuration - ',
        TAB_CONFIG_NOTIFICATION_CHECKBOX_LABEL: 'Beagle notification tab configuration.',
        TAB_CONFIG_NARRATIVE_BOARD_CHECKBOX_LABEL: 'Beagle narrative board tab configuration.',
        TAB_CONFIG_NOTIFICATION_CHECKBOX_VALUE: 'Notification',
        TAB_CONFIG_NARRATIVE_BOARD_CHECKBOX_VALUE: 'Narrative Board'
    },
    MAXLENGTH: {
        TEXT: 100,
    },
    MAXCOMMENTLENGTH: 5,
    MINCOMMENTLENGTH: 2,
    MINREPLYCOMMENTLENGTH: 1,
    LICENSE_EXPIRE: 'license is expired.',
    GROUPBYCOLUMN: 'groupby_column',
    FILTERCONJUCTION: {
        AND: 'and'
    },
    FILTEROPERATOR: {
        IN: 'IN'
    },
    BUTTONTEXT: {
        FILTERS: 'Filters',
        NOTIFYME: 'Notify me',
        NARRATIVEBOARD: 'Narrative Board',
        CLEARALL: 'Clear All',
        SUBMIT: 'Submit',
        RUNSIMULATION:'Run Simulation'
    },
    NOTIFICATION: {
        SUCCESS: 'notificaton_success',
        FAILURE: 'notification_failure',
        NOTIFYME: 'notify_me',
        FAILUREMESSAGE: 'Failure',
        SUCCESSMESSAGE: 'Success'
    },
    COMMENTTYPE: {
        TEXT: 'text',
        USERTAG: 'user_tag'
    },
    WEBAPP:'webapp',
    NARRATIVE_BOARD_PAGINATION_LIMIT: 10,
    COMMENT_MENTION_MARKUP: '@{^@{__id__|^@^|__display__}^@^}',
    CHARTTYPE: {
        OPENCHART: { chart_id: 27, chart_name: 'Open chart' },
        TABLE: { chart_id: 1, chart_name: 'Table' },
        LINE: { chart_id: 2, chart_name: 'Basic line' },
        STACKEDCOLUMN: { chart_id: 3, chart_name: 'Stacked column' },
        SYNCHRONIZEDCHART: { chart_id: 4, chart_name: 'Synchronized charts' },
        COLUMN: { chart_id: 5, chart_name: 'Column' },
        AREA: { chart_id: 6, chart_name: 'Area' },
        MULTIPLEAXES: { chart_id: 7, chart_name: 'Multiple axes' },
        SPARKLINE: { chart_id: 8, chart_name: 'Sparkline charts' },
        PACKEDBUBBLE: { chart_id: 9, chart_name: 'Packed bubble charts' },
        TREEMAP: { chart_id: 10, chart_name: 'Tree map with levels' },
        BUBBLERADIAL3D: { chart_id: 11, chart_name: 'Bubbles with Radial Gradient Fill' },
        PIELEGEND: { chart_id: 12, chart_name: 'Pie legend' },
        PIEDONUT: { chart_id: 13, chart_name: 'Pie Donut' },
        COLUMNDRILLDOWN: { chart_id: 14, chart_name: 'Column With Drilldown' },
        SCATTERPLOT: { chart_id: 15, chart_name: 'Scatter plot' },
        VARIWIDE: { chart_id: 16, chart_name: 'Column With Drilldown' },
        VARIABLERADIUSPIE: { chart_id: 17, chart_name: 'Variable radius pie' },
        COMBO: { chart_id: 18, chart_name: 'Combo Chart' },
        BAR: { chart_id: 19, chart_name: 'Bar' },
        STACKEDBAR: { chart_id: 20, chart_name: 'Stacked bar' },
        DCFILTERLINECHART: { chart_id: 21, chart_name: 'DC filter line chart' }
    },
    PVP:{
    QUERY:'Query : ',
    CORRECTEDQUERY:'Corrected Query : ',
    UNITOPTIONS:['percentage','absolute'],
    NOTES:{
      FIRSTNOTE:'1. TT: PE calculated at Sell-In level only (Sigma SKU only)',
      SECONDNOTE:'2. MT: PE Calculated at Sell-Out level (All Manufacturer are present)',
      THIRDNOTE:'3. Market share calculations will be available for MT only',
    },
    MOBILEWIDTH:420,
    },
    HOME:{
      HEADING:'Welcome to Beagle GPT',
      SUBHEADING:'Powered by GPT, Beagle provides fast and real-time insights.',
      INTRODUCTION:'Hi, I’m Beagle GPT,chat with me to get instant data and insights.',
      BEAGLEANALYTICSURL:'https://beagleanalytics.ai/',
    },
    CHARTOPTIONS: 'chart options',
    CARDNOTEHEADER: 'Note:',
    FALLBACKFIRSTMESSAGE:`We're tackling a technical hiccup right now, our team is already working hard to fix this.`,
    FALLBACKSECONDMESSAGE:"Please be patient, and give it another shot in a little while.",
    ACCESSREVOKED:"Your Access To This VA/Card Has Been Revoked",
    TOKENFALLBACK:"MFA Authentication failed",
    CSVDOWNLOADMESSAGE:"Due to Microsoft Teams limitations, the download csv feature might not work as expected on mobile devices. We recommend using a desktop or laptop to download the csv file.",
    SAMPLETEMPLATECONFIG:{
        "id": 1,
        "name": "Point In Time",
        "description": "",
        "type": "POWERBI",
        "excel_database_id": -1,
        "connection_id": 269,
        "table_id": 719,
        "excel_table_id": -1,
        "sorting_column": "",
        "sorting_column_index": -1,
        "sorting_column_time_period": "",
        "view_id": "",
        "report_id": "",
        "filter": [],
        "default_filter": [],
        "teams_filter_column_options": [
          {
            "table_id": 719,
            "table_name": "KOF Pa",
            "column_name": "PROMO_BILLED_STORE",
            "column_id": 9928
          },
          {
            "table_id": 719,
            "table_name": "KOF Pa",
            "column_name": "PROMO_DESC",
            "column_id": 9933
          }
        ],
        "chart_config": [
          {
            "chart_id": 1,
            "chart_name": "Table"
          },
          {
            "chart_id": 2,
            "chart_name": "Basic line"
          }
        ],
        "default_template_view": {
          "chart_id": 1,
          "chart_name": "Table"
        },
        "data_rows_font_size": "11px",
        "distribution_column": {
          "bind_col_name": "KOF Pa/beagle-table-sep-/Key 1",
          "display_name": "Key 1",
          "table_id": 719,
          "column_id": 9926,
          "target_key": "Column Drop Target",
          "sorting_order": "ascending",
          "style": {
            "backgroundColor": "#808080",
            "color": "white",
            "fontSize": "12px"
          }
        },
        "heading_2": {
          "bind_col_name": "KOF Pa/beagle-table-sep-/MONTH",
          "style": {
            "backgroundColor": "#808080",
            "color": "white",
            "fontSize": "12px"
          },
          "target_key": "Column Drop Target",
          "display_name": "MONTH",
          "table_id": 719,
          "column_id": 9954
        },
        "heading_2_columns": [
          {
            "bind_col_name": "1. #Promos",
            "target_key": "Metrix",
            "sorting_order": "ascending",
            "style": {
              "backgroundColor": "#808080",
              "color": "white",
              "fontSize": "10px"
            },
            "metric_config": {
              "type": "POWERBI",
              "metrics": [
                {
                  "measure_id": 8963,
                  "metric_name": "1. #Promos",
                  "table_id": 719,
                  "type": "default_measure"
                }
              ]
            },
            "conditional_formatting_config": {
              "conditional_formatting": "Data Bars",
              "start_color": [
                255,
                0,
                0
              ],
              "middle_color": [
                255,
                255,
                255
              ],
              "end_color": [
                0,
                255,
                0
              ]
            }
          },
          {
            "bind_col_name": "",
            "target_key": "Metrix",
            "sorting_order": "ascending",
            "style": {
              "backgroundColor": "#808080",
              "color": "white",
              "fontSize": "10px"
            },
            "metric_config": {},
            "conditional_formatting_config": {
              "conditional_formatting": "",
              "start_color": [
                255,
                0,
                0
              ],
              "middle_color": [
                255,
                255,
                255
              ],
              "end_color": [
                0,
                255,
                0
              ]
            }
          },
          {
            "bind_col_name": "",
            "target_key": "Metrix",
            "sorting_order": "ascending",
            "style": {
              "backgroundColor": "#808080",
              "color": "white",
              "fontSize": "10px"
            },
            "metric_config": {},
            "conditional_formatting_config": {
              "conditional_formatting": "",
              "start_color": [
                255,
                0,
                0
              ],
              "middle_color": [
                255,
                255,
                255
              ],
              "end_color": [
                0,
                255,
                0
              ]
            }
          },
          {
            "bind_col_name": "",
            "target_key": "Metrix",
            "sorting_order": "ascending",
            "style": {
              "backgroundColor": "#808080",
              "color": "white",
              "fontSize": "10px"
            },
            "metric_config": {},
            "conditional_formatting_config": {
              "conditional_formatting": "",
              "start_color": [
                255,
                0,
                0
              ],
              "middle_color": [
                255,
                255,
                255
              ],
              "end_color": [
                0,
                255,
                0
              ]
            }
          }
        ],
        "dataset_id": 504
      },
    SAMPLETEMPLATECONFIG2: {
        "id": 1,
        "name": "Point In Time",
        "type": "Excel",
        "excel_database_id": 695,
        "connection_id": -1,
        "table_id": 15094,
        "excel_table_id": 773,
        "sorting_column": "",
        "sorting_column_index": -1,
        "sorting_column_time_period": "",
        "view_id": "",
        "report_id": "",
        "filter": [],
        "default_filter": [],
        "teams_filter_column_options": [
            {
                "table_id": 15094,
                "table_name": "data_7_Small_Excel__Athena_Filter",
                "column_name": "Region",
                "column_id": 229767
            }
        ],
        "chart_config": [
            {
                "chart_id": 1,
                "chart_name": "Table"
            },
            {
                "chart_id": 5,
                "chart_name": "Column"
            },
            {
                "chart_id": 3,
                "chart_name": "Stacked column"
            },
            {
                "chart_id": 2,
                "chart_name": "Basic line"
            }
        ],
        "default_template_view": {
            "chart_id": 5,
            "chart_name": "Column"
        },
        "data_rows_font_size": "11px",
        "distribution_column": {
            "bind_col_name": "data_7_Small_Excel__Athena_Filter.Region",
            "display_name": "Region",
            "table_id": 15094,
            "column_id": 229767,
            "target_key": "Column Drop Target",
            "sorting_order": "ascending",
            "style": {
                "backgroundColor": "#808080",
                "color": "white",
                "fontSize": "12px"
            }
        },
        "heading_2": {
            "bind_col_name": "time_period",
            "style": {
                "backgroundColor": "#808080",
                "color": "white",
                "fontSize": "12px"
            },
            "target_key": "Time Dimension"
        },
        "heading_2_columns": [
            {
                "bind_col_name": "Online Orders",
                "target_key": "Metrix",
                "sorting_order": "ascending",
                "style": {
                    "backgroundColor": "#808080",
                    "color": "white",
                    "fontSize": "10px"
                },
                "metric_config": {
                    "type": "Excel",
                    "connection_id": 1,
                    "selected_tables": [
                        {
                            "id": 15094,
                            "name": "data_7_Small_Excel__Athena_Filter"
                        }
                    ],
                    "metrics": [
                        {
                            "metric_name": "Online Orders",
                            "id": 26421,
                            "applied_function": 1,
                            "applied_function_name": "Sum",
                            "function_config": {
                                "dimensions": 1,
                                "field1": {
                                    "table_id": 15094,
                                    "table_name": "Athena_Filter",
                                    "column_id": 229772,
                                    "column_name": "Total",
                                    "column_alias": "",
                                    "column_default_datatype": "String",
                                    "constant_value": 0,
                                    "field_type": "column_name"
                                },
                                "time_dimension": {
                                    "table_id": 15094,
                                    "table_name": "Athena_Filter",
                                    "column_id": 229766,
                                    "column_name": "OrderDate",
                                    "column_alias": "",
                                    "column_default_datatype": "String"
                                },
                                "time_period": "YTD"
                            }
                        }
                    ]
                },
                "conditional_formatting_config": {
                    "conditional_formatting": "",
                    "pivot": 0,
                    "start_color": [
                        255,
                        0,
                        0
                    ],
                    "middle_color": [
                        255,
                        255,
                        255
                    ],
                    "end_color": [
                        0,
                        255,
                        0
                    ]
                }
            },
            {
                "bind_col_name": "",
                "target_key": "Metrix",
                "sorting_order": "ascending",
                "style": {
                    "backgroundColor": "#808080",
                    "color": "white",
                    "fontSize": "10px"
                },
                "metric_config": {},
                "conditional_formatting_config": {
                    "conditional_formatting": "",
                    "pivot": 0,
                    "start_color": [
                        255,
                        0,
                        0
                    ],
                    "middle_color": [
                        255,
                        255,
                        255
                    ],
                    "end_color": [
                        0,
                        255,
                        0
                    ]
                }
            },
            {
                "bind_col_name": "",
                "target_key": "Metrix",
                "sorting_order": "ascending",
                "style": {
                    "backgroundColor": "#808080",
                    "color": "white",
                    "fontSize": "10px"
                },
                "metric_config": {},
                "conditional_formatting_config": {
                    "conditional_formatting": "",
                    "pivot": 0,
                    "start_color": [
                        255,
                        0,
                        0
                    ],
                    "middle_color": [
                        255,
                        255,
                        255
                    ],
                    "end_color": [
                        0,
                        255,
                        0
                    ]
                }
            },
            {
                "bind_col_name": "",
                "target_key": "Metrix",
                "sorting_order": "ascending",
                "style": {
                    "backgroundColor": "#808080",
                    "color": "white",
                    "fontSize": "10px"
                },
                "metric_config": {},
                "conditional_formatting_config": {
                    "conditional_formatting": "",
                    "pivot": 0,
                    "start_color": [
                        255,
                        0,
                        0
                    ],
                    "middle_color": [
                        255,
                        255,
                        255
                    ],
                    "end_color": [
                        0,
                        255,
                        0
                    ]
                }
            }
        ],
        "table_formatting": {
            "header": {
                "backgroundColor": "#E1E0E0",
                "fontColor": "#000000",
                "fontSize": "12px",
                "fontFamily": "unset",
                "textAlign": "center",
                "alignItems": "center",
                "fontWeight": "700"
            },
            "dataBars": {
                "positive_color_gradient": [
                    "#1C9F2E",
                    "#8CE658"
                ],
                "negative_color_gradient": [
                    "#FF4747",
                    "#FF7D7D"
                ]
            },
            "colorFormat": {
                "start_color": [
                    255,
                    0,
                    0
                ],
                "middle_color": [
                    255,
                    255,
                    255
                ],
                "end_color": [
                    0,
                    255,
                    0
                ]
            },
            "general": {
                "striped": false
            },
            "column": {
                "fontWeight": "700",
                "fontSize": "12px",
                "fontFamily": "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                "textAlign": "center",
                "alignItems": "center",
                "trendMetricTextAlign": "left"
            },
            "border": {
                "outerBorderColor": "#404040",
                "innerBorderColor": "#a6a6a6"
            },
            "default_colors": [
                "#46BEBD",
                "#9D9D9D",
                "#FDB45C",
                "#4D5360",
                "#F9676A",
                "#468BA8",
                "#D9D9D9",
                "#9EDE73",
                "#B83B5E",
                "#794C74"
            ]
        },
        "time_period_filter": {},
        "updated_with_latest_metrics": true,
        "user_filters": [
            [
                {
                    "table_id": 15094,
                    "excel_table_id": 773,
                    "name": "data_7_Small_Excel__Athena_Filter.Region",
                    "column_id": 229767,
                    "operator": "IN",
                    "regex": "Exact",
                    "conjuction": "",
                    "values": [
                        "Central",
                        "East",
                        "West"
                    ]
                }
            ]
        ],
        "applied_filters": [],
        "is_updated_config_required": true,
        "last_updated_at": "2020-12-21 00:00:00",
        "last_updated_at_for_comparison": "2020-12-21",
        "from_calculated_table": false
    },
}
